"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.postESSData = exports.submitData = exports.getData = exports.emptyUsageLocation = exports.HttpError = void 0;
const EventEmitter_1 = require("../utils/EventEmitter");
const luxon_1 = require("luxon");
const logger_1 = require("../logger");
const fetchUtils_1 = require("./fetchUtils");
class HttpError extends Error {
    constructor(statusCode, message) {
        super();
        this.statusCode = statusCode;
        this.message = message;
    }
}
exports.HttpError = HttpError;
exports.emptyUsageLocation = 'missingLocation';
const getData = (params, currentStage = fetchUtils_1.Stage.BETA) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const method = params.method ? params.method : 'GET';
    const start = luxon_1.DateTime.now();
    const host = params.host || (0, fetchUtils_1.getHost)(currentStage);
    const body = (_a = params.body) !== null && _a !== void 0 ? _a : null;
    const usageLocation = params.usageLocation
        ? params.usageLocation
        : exports.emptyUsageLocation;
    let clientId = fetchUtils_1.AtoZClientId.TIME_OFF;
    if (params.eventName == EventEmitter_1.taaEvents.GET_PAY_CALENDAR)
        clientId = fetchUtils_1.AtoZClientId.PAY_BREAKDOWN;
    const headers = yield (0, fetchUtils_1.getApiGatewayHeaders)(currentStage, clientId);
    const response = yield fetch(`${host}${params.path}`, {
        method,
        headers,
        credentials: (0, fetchUtils_1.getCredentials)(currentStage),
        body: body ? JSON.stringify(body) : undefined
    });
    if (params.eventName) {
        EventEmitter_1.Emitter.emit(params.eventName, {
            data: response,
            responseCode: response.status
        });
    }
    const duration = luxon_1.DateTime.now().diff(start).milliseconds;
    emitUsageMetrics(params.path, usageLocation, params.metaData, duration);
    logHttpResponse(method, params.path, response.clone(), duration, params.metaData, usageLocation);
    if (!response.ok) {
        throw new HttpError(response.status, yield response.text());
    }
    return response.json();
});
exports.getData = getData;
const submitData = (currentStage) => (params) => __awaiter(void 0, void 0, void 0, function* () {
    const start = luxon_1.DateTime.now();
    const host = params.host || (0, fetchUtils_1.getHost)(currentStage);
    const usageLocation = params.usageLocation
        ? params.usageLocation
        : exports.emptyUsageLocation;
    let clientId = fetchUtils_1.AtoZClientId.TIME_OFF;
    if (params.eventName == EventEmitter_1.taaEvents.CREATE_CTK_CASE) {
        clientId = fetchUtils_1.AtoZClientId.MY_HR_GATEWAY;
    }
    const headers = yield (0, fetchUtils_1.getApiGatewayHeaders)(currentStage, clientId);
    const response = yield fetch(`${host}${params.path}`, {
        method: params.method,
        headers,
        credentials: (0, fetchUtils_1.getCredentials)(currentStage),
        body: JSON.stringify(params.body)
    });
    if (params.eventName) {
        EventEmitter_1.Emitter.emit(params.eventName, {
            data: response,
            responseCode: response.status
        });
    }
    const duration = luxon_1.DateTime.now().diff(start).milliseconds;
    emitUsageMetrics(params.path, usageLocation, params.metaData, duration);
    logHttpResponse(params.method, params.path, response.clone(), duration, params.metaData, usageLocation);
    if (!response.ok) {
        throw new HttpError(response.status, yield response.text());
    }
    return response.json();
});
exports.submitData = submitData;
const postESSData = (currentStage) => (params) => __awaiter(void 0, void 0, void 0, function* () {
    const usageLocation = params.usageLocation
        ? params.usageLocation
        : exports.emptyUsageLocation;
    const start = luxon_1.DateTime.now();
    const method = 'POST';
    const response = yield fetch(params.path, {
        method,
        headers: (0, fetchUtils_1.getEsspHeaders)(),
        credentials: (0, fetchUtils_1.getCredentials)(currentStage),
        body: JSON.stringify(params.body)
    });
    if (params.eventName) {
        EventEmitter_1.Emitter.emit(params.eventName, {
            data: response,
            responseCode: response.status
        });
    }
    const duration = luxon_1.DateTime.now().diff(start).milliseconds;
    emitUsageMetrics(params.path, usageLocation, params.metaData, duration);
    logHttpResponse(method, params.path, response.clone(), duration, params.metaData, usageLocation);
    if (!response.ok) {
        throw new Error();
    }
    return response;
});
exports.postESSData = postESSData;
const logHttpResponse = (method, path, response, responseTime, metaData, usageLocation) => __awaiter(void 0, void 0, void 0, function* () {
    const { clientName, apiName, isLogResponse } = metaData || {};
    const basicLogContext = {
        method,
        url: response.url,
        statusCode: response.status,
        responseTime,
        unit: 'millisecond',
        clientName,
        usageLocation
    };
    const message = `HTTPRequest.${apiName || path.split('?')[0]}.${response.ok ? 'Response' : 'Error'}`;
    if (!response.ok) {
        logger_1.logger.error(message, Object.assign(Object.assign({}, basicLogContext), { data: yield response.text() }));
    }
    else {
        logger_1.logger.info(message, Object.assign(Object.assign({}, basicLogContext), { data: isLogResponse ? yield response.json() : undefined }));
    }
});
const emitUsageMetrics = (path, usageLocation, metaData, duration) => {
    const { apiName } = metaData || {};
    const metricName = apiName || path.split('?')[0];
    logger_1.logger.emitCountMetric({
        metricName: `${metricName}.count`,
        dimensions: {
            MetricType: logger_1.MetricCategory.API_METRICS,
            usageLocation: usageLocation
        }
    });
    logger_1.logger.emitLatencyMetric({
        metricName: `${metricName}.latency`,
        metricValue: duration,
        dimensions: {
            MetricType: logger_1.MetricCategory.API_METRICS,
            usageLocation: usageLocation
        }
    });
};
